import { render, staticRenderFns } from "./UpdateShipmentMethodsView.vue?vue&type=template&id=aa2dd756"
import script from "./UpdateShipmentMethodsView.vue?vue&type=script&lang=js"
export * from "./UpdateShipmentMethodsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports